import { render, staticRenderFns } from "./IconInput.vue?vue&type=template&id=381b83db&scoped=true"
import script from "./IconInput.vue?vue&type=script&lang=js"
export * from "./IconInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b83db",
  null
  
)

export default component.exports